//import NPM, LIB
import React, { useState, useEffect } from "react";
import Moment from "moment";
import { sub, format } from "date-fns";
import { useDispatch, useSelector } from "react-redux";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import ptBrLocale from "date-fns/locale/pt-BR";
import MicroModal from "micromodal";

//import ACTIONS
import convertUnicodeEmoji from "../../../../actions/convertUnicodeEmoji";
import {
  DetailsAnotationsida,
  GetInteractionsModal,
} from "../../../../actions";

//import COMPONENTS
import Typography from "../../../Typography";
import Loading from "../../../Loading";
import UserPhoto from "../../../UserPhoto/userphoto";

//import CSS
import "../../../../build/css/modal.css";
import "./anotation-modal.css";

//import IMG,SVG
import CLIENTE from "../../../../build/images/user.svg";
import { ReactComponent as IconDoc } from "../../../../build/images/attendanceIcons/document-text.svg";
import { ReactComponent as IconCalendar } from "../../../../build/images/Calendar-2.svg";
import { ReactComponent as IconTimer } from "../../../../build/images/timer.svg";
import { ReactComponent as IconMessageNull } from "../../../../build/images/messages-3.svg";

let criticData = [];
let anotData = [];
// let now = Moment().subtract(1, "month");
// let dateinitsearchanotation = now.format("YYYY-MM-DD");
let dateinitsearchanotation = sub(new Date(), {
  months: 1,
});
// let dateendsearchanotation = Moment().format("YYYY-MM-DD");
let dateendsearchanotation = new Date();

export default function NewAnotationModal(props) {
  const dispatch = useDispatch();
  const contactId = useSelector((state) => state.atendimento);
  const infoModal = useSelector((state) => state.interactionsmodal);

  const [visibleCritic, setVisibleCritic] = useState(false);
  const [criticSelected, setCriticSelected] = useState([
    {
      critSelec: "Todos",
      iconCrit: "",
      idCrit: "",
    },
  ]);
  const CriticalityData = useSelector((state) => state.criticalitys);
  const anotationsData = useSelector((state) => state.detailsanotations);
  const [buttonLearnMore, setButtonLearnMore] = useState(false);
  const [expandLearn, setExpandLearn] = useState([]);
  const [dataInitial, setDataInitial] = useState(dateinitsearchanotation);
  const [dataFinal, setDataFinal] = useState(dateendsearchanotation);
  //   let dataInitial = dataInit;
  //   let dataFinal = dataFim;
  const [loading, setLoading] = useState(false);
  const [ContactId, setContactId] = useState({});

  const SelectCriticitys = (
    desccriticidade,
    idcriticidade,
    tipocriticidade
  ) => {
    setCriticSelected([
      {
        critSelec: desccriticidade,
        iconCrit: tipocriticidade,
        idCrit: idcriticidade,
      },
    ]);
    setVisibleCritic(!visibleCritic);
  };

  const checkExpandLearn = (e, idanot) => {
    var checkClick = expandLearn.indexOf(idanot) != -1 ? true : false;
    var temp = [];

    if (!checkClick) {
      temp = expandLearn.concat([idanot]);
    } else {
      temp = expandLearn.filter(function (val) {
        return val != idanot;
      });
    }
    setExpandLearn(temp);
  };

  const buttonSearchAnotation = (e) => {
    var erro = 0;
    // const datainit = document.getElementById("date_init_search").value;
    const datainit = format(dataInitial, "yyyy-MM-dd");
    // const datafim = document.getElementById("date_fim_search").value;
    const datafim = format(dataFinal, "yyyy-MM-dd");
    const idcriticidade =
      criticSelected.length !== 0 ? criticSelected[0].idCrit : "";

    let comparation = Moment(datainit).isBefore(datafim);

    if (datainit === "") erro = 1;

    if (datafim === "") erro = 1;

    if (idcriticidade === 0) erro = 1;

    if (comparation === false) {
      erro = 1;
      if (datainit === datafim) {
        erro = 0;
      }
    }

    if (erro === 0) {
      setLoading(true);
      dispatch(
        DetailsAnotationsida(
          datainit,
          datafim,
          idcriticidade,
          ContactId.telefone
        )
      );
    }
  };

  function exitModal(e, modal) {
    // if (originModal === "contacts") {
    //   MicroModal.close("modal__historico-atendimento-details");
    //   MicroModal.show("modal__agenda");
    // } else if (originModal === "") {
    MicroModal.close(modal);
    dispatch(GetInteractionsModal("", ""));
    setDataInitial(dateinitsearchanotation);
    setDataFinal(dateendsearchanotation);
    // }
  }

  function createJSON(item) {
    if (item) {
      var mensagem_tratada = item.replace(/¿/gi, "\n");
      mensagem_tratada = mensagem_tratada.replace(/§/gi, "\r\n");
      let valor = 1;
      try {
        mensagem_tratada =
          '{"' +
          valor +
          '": [{"mensagem_tratada":"' +
          mensagem_tratada +
          '"}]}';
        var obj = JSON.parse(mensagem_tratada);
        mensagem_tratada = obj[1][0].mensagem_tratada;
      } catch (e) {
        mensagem_tratada = item;
      }
      return mensagem_tratada;
    }
  }

  if (CriticalityData.length != 0) {
    criticData = CriticalityData.criticalitys;
  }

  // if (anotationsData.length != 0) {
  //   anotData = anotationsData.detailsanotations;
  // }

  useEffect(() => {
    if (anotationsData.length != 0) {
      anotData = anotationsData.detailsanotations;
      setLoading(false);
    }
  }, [anotationsData]);

  useEffect(() => {
    if (contactId && !infoModal.telefone) {
      setContactId(contactId);
    } else if (infoModal.telefone) {
      setContactId(infoModal);
    } else if (props.ContactId) {
      setContactId(props.ContactId);
    }
  }, [props.ContactId, infoModal, contactId]);

  return (
    <div
      className="modal micromodal-slide"
      id="modal__anotacoes-details-new"
      aria-hidden="true"
      role="dialog"
    >
      <div className="modal__overlay" tabIndex="-1">
        <div
          className="modal__container modal-size"
          role="dialog"
          aria-modal="true"
          aria-labelledby="modal__anotacoes__title"
        >
          <header className="modal__header">
            <Typography.H2 color={"blue-selected-4"} weight={700}>
              Anotações
            </Typography.H2>
            <button
              className="modal__close"
              aria-label="Close modal"
              data-micromodal-close
              onClick={(event) =>
                exitModal(event, "modal__anotacoes-details-new")
              }
            ></button>
          </header>
          <main className="modal__content" id="modal__anotacoes__content">
            <div className="anotc__info">
              <Typography.H4 color={"blue-selected-5"}>
                {createJSON(ContactId.cliente)}
              </Typography.H4>
              <div className="modal__info-total">
                <IconDoc />
                <span className="anotc__info-text">
                  Total de{" "}
                  <span className="anotc__counter">{anotData.length}</span>{" "}
                  anotações
                </span>
              </div>
            </div>
            <div className="anotc__wrapper">
              <div className="anotc__mp">
                <div className="anotc__mp-ctrL">
                  <div className="anotc__mp-date">
                    <Typography.H5 color={"black-85"}>
                      Deseja buscar as anotação de qual período?
                    </Typography.H5>
                    <div className="anotc__mp-date-wrapper">
                      <div className="modal_date-start">
                        <Typography.H6 color={"gray-600"}>De:</Typography.H6>
                        <LocalizationProvider
                          dateAdapter={AdapterDateFns}
                          adapterLocale={ptBrLocale}
                        >
                          <DatePicker
                            value={dataInitial}
                            onChange={(newValue) => setDataInitial(newValue)}
                            maxDate={dataFinal}
                          />
                        </LocalizationProvider>
                      </div>
                      <div className="modal_date-end">
                        <Typography.H6 color={"gray-600"}>Até:</Typography.H6>

                        <LocalizationProvider
                          dateAdapter={AdapterDateFns}
                          adapterLocale={ptBrLocale}
                        >
                          <DatePicker
                            value={dataFinal}
                            onChange={(newValue) => setDataFinal(newValue)}
                            minDate={dataInitial}
                          />
                        </LocalizationProvider>
                      </div>
                    </div>
                  </div>
                  <div className="anotc__mp-critic">
                    <Typography.H6 color={"gray-600"}>
                      E com qual nível de criticidade?
                    </Typography.H6>
                    <div className="anotc__mp-critic-wrapper">
                      <button
                        className="anotc__mp-critic-btn"
                        onClick={() => setVisibleCritic(!visibleCritic)}
                      >
                        {criticSelected.length !== 0
                          ? criticSelected[0].critSelec
                          : ""}
                        <i className="anotc__mp-critic-icon material-icons">
                          keyboard_arrow_down
                        </i>
                      </button>
                      <div
                        className={
                          visibleCritic
                            ? "anotc__mp-critic-options active"
                            : "anotc__mp-critic-options"
                        }
                      >
                        <ul className="anotc__mp-critic-list">
                          <li
                            className="anotc__mp-critic-item"
                            onClick={() => SelectCriticitys("Todos", "", "")}
                          >
                            <span className="anotc__mp-critic-dot">•</span>
                            <Typography.H6 color={"black"}>Todos</Typography.H6>
                            {/* Todos */}
                          </li>
                          {criticData.map((desc) => (
                            <li
                              key={desc.id}
                              className="anotc__mp-critic-item"
                              onClick={() =>
                                SelectCriticitys(
                                  desc.description,
                                  desc.id,
                                  desc.class_criticality
                                )
                              }
                            >
                              <span
                                className={
                                  "anotc__mp-critic-dot " +
                                  desc.class_criticality
                                }
                              >
                                •
                              </span>
                              <Typography.H6 color={"black"}>
                                {desc.description}
                              </Typography.H6>
                            </li>
                          ))}
                        </ul>
                      </div>
                    </div>
                  </div>
                  <button
                    className={`anotc__mp-btn btn-modals ${
                      loading ? "search-time" : ""
                    }`}
                    onClick={(event) =>
                      loading ? null : buttonSearchAnotation(event)
                    }
                  >
                    Filtrar
                  </button>
                </div>

                <div className={`anotc__mp-result`}>
                  <div className="anotc__mp-search">
                    <span className="material-icons anotc__mp-search-icon">
                      expand_less
                    </span>
                    <span className="material-icons anotc__mp-search-icon">
                      expand_more
                    </span>
                    <input
                      type="text"
                      className="anotc__mp-search-input"
                      placeholder="Pesquisar..."
                    />
                    <button className="anotc__mp-search-btn">Concluir</button>
                  </div>

                  {loading ? (
                    <Loading.Paperplane fullPage={true} loadingModal={true} />
                  ) : anotData.length > 0 ? (
                    <ul className="anotc__mp-result-list">
                      {anotData.map((details) => (
                        <li key={details.id} className="anotc__mp-result-item">
                          <button className="anotc__mp-result-avatar">
                            <UserPhoto
                              size="medium"
                              onClick={(event) => this.showUserMidia(event)}
                            />
                            {/* <div
                              className="user-photo"
                              onClick={(event) => this.showUserMidia(event)}
                            >
                              <img src={CLIENTE} alt="" />
                            </div> */}
                          </button>
                          <div className="anotc__mp-result-container">
                            <div className="anotc__mp-result-item-top">
                              <div className="anotc__mp-result-item-info">
                                <p className="anotc__mp-result-item-name">
                                  {createJSON(ContactId.cliente)}
                                </p>
                                <p className="anotc__mp-result-item-title">
                                  {details.usuario_anotacao}
                                </p>
                              </div>
                              <div className="anotc__mp-result-item-critic">
                                <div className="anotc__mp-result-item-fulltime">
                                  <span className="anotc__mp-result-item-datehour">
                                    <IconCalendar />
                                    <Typography.H6 color={"gray-180"}>
                                      {details.data_anotacao}
                                    </Typography.H6>
                                  </span>

                                  <span className="anotc__mp-result-item-datehour">
                                    <IconTimer />
                                    <Typography.H6 color={"gray-180"}>
                                      {details.hora_anotacao}
                                    </Typography.H6>
                                  </span>
                                </div>
                                <div
                                  className={
                                    "anotc__mp-result-item-level " +
                                    details.class_criticality
                                  }
                                >
                                  <Typography.H6 color={"white"}>
                                    {details.desc_criticidade}
                                  </Typography.H6>
                                </div>
                              </div>
                            </div>
                            <div
                              className={
                                buttonLearnMore ||
                                expandLearn.indexOf(details.id) != -1
                                  ? "anotc__mp-result-item-content auto"
                                  : "anotc__mp-result-item-content"
                              }
                            >
                              {details.desc_anotacao}
                            </div>
                            <button
                              className="anotc__mp-result-btn"
                              onClick={(event) =>
                                checkExpandLearn(event, details.id)
                              }
                            >
                              {/* <span className="anotc__mp-result-span material-icons">
                              {buttonLearnMore ||
                              expandLearn.indexOf(details.id) != -1
                                ? "remove_circle_outline"
                                : "add_circle_outline"}
                            </span> */}
                              <span
                                className={
                                  buttonLearnMore ||
                                  expandLearn.indexOf(details.id) != -1
                                    ? "hack"
                                    : "hack active"
                                }
                              >
                                {" "}
                                Ler mais
                              </span>
                              <span
                                className={
                                  buttonLearnMore ||
                                  expandLearn.indexOf(details.id) != -1
                                    ? "hack active"
                                    : "hack"
                                }
                              >
                                {" "}
                                Ler menos
                              </span>
                            </button>
                          </div>
                        </li>
                      ))}
                    </ul>
                  ) : (
                    <div className="modal__nully">
                      <div className="modal__nully-icon">
                        <IconMessageNull />
                      </div>
                      <div className="modal__nully-text">
                        <Typography.H4 color={"black"}>
                          Não há nenhuma anotação.
                        </Typography.H4>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </main>
        </div>
      </div>
    </div>
  );
}
